<template>
  <div class="modal-overlay">
    <div
      ref="kt_modal_alterar_preco_venda"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
      id="kt_modal_alterar_preco_venda"
    >
      <div
        class="modal-dialog modal-md mw-400px modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <div class="card-title d-flex align-items-center">
              <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                <inline-svg src="media/icons/duotune/finance/fin010.svg" />
              </span>
              <h3 class="fw-bold m-0 text-gray-800">Alteração de Preço</h3>
            </div>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="$emit('exibirModalAlterarPrecoVenda', false)"
            >
              <span class="svg-icon svg-icon-1 svg-icon lh-0">
                <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-4">
            <div class="fs-7 mt-2 mb-2">
              <div class="text-danger">
                {{
                  "A dedução ou acréscimo é calculada em cima do preço do cadastro"
                }}
              </div>
            </div>
            <div class="card border border-rounded border-gray-300 mb-4 p-6">
              <div class="fs-5 mt-0 mb-4">
                <b class="text-danger">{{ "Tipo Alteração" }}</b>
              </div>
              <div class="row">
                <div class="col-6 fv-row d-flex justify-content-start mb-4">
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="rbAlterar"
                      id="rbDeduzirReal"
                      @change="atualizar()"
                      checked
                    />
                    <label
                      class="form-check-label fs-6 fw-bold"
                      for="rbDeduzirReal"
                    >
                      Deduzir em R$
                    </label>
                  </div>
                </div>
                <div class="col-6 fv-row d-flex justify-content-start mb-4">
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="rbAlterar"
                      id="rbDeduzirPorcentagem"
                      @change="atualizar()"
                    />
                    <label
                      class="form-check-label fs-6 fw-bold"
                      for="rbDeduzirPorcentagem"
                    >
                      Deduzir em %
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6 fv-row d-flex justify-content-start">
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="rbAlterar"
                      id="rbAcrescimoReal"
                      @change="atualizar()"
                    />
                    <label
                      class="form-check-label fs-6 fw-bold"
                      for="rbAcrescimoReal"
                    >
                      Acréscimo em R$
                    </label>
                  </div>
                </div>
                <div class="col-6 fv-row d-flex justify-content-start">
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="rbAlterar"
                      id="rbAcrescimoPorcentagem"
                      @change="atualizar()"
                    />
                    <label
                      class="form-check-label fs-6 fw-bold"
                      for="rbAcrescimoPorcentagem"
                    >
                      Acréscimo em %
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card border border-rounded border-gray-300 pt-4">
              <div class="row">
                <div class="col-12 mb-4">
                  <div
                    class="fv-row flex-column d-flex align-items-center text-center"
                  >
                    <label class="form-label">{{ this.labelDeduzir }}</label>
                    <CurrencyInput
                      id="txtValorAlteracao"
                      class="form-control fs-1 mw-200px"
                      style="text-align: center"
                      v-model="this.valorAlteracao"
                      :options="options"
                      @change="this.bloquearValorNegativo()"
                      @keydown.stop.prevent.enter="this.confirmar(false)"
                    ></CurrencyInput>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 pt-4">
                <button
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Ao confirmar irá adicionar ou subtrair o valor informado do preço de venda dos itens."
                  class="btn btn-primary svg-icon-white w-100"
                  @click="confirmar(false)"
                >
                  Aplicar alteração de preço de venda
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 pt-4">
                <button
                  class="btn btn-success svg-icon-white w-100"
                  @click="confirmar(true)"
                >
                  Voltar preço de venda do cadastro
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end">
            <button
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="$emit('exibirModalAlterarPrecoVenda', false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CurrencyInput from "@/components/text/CurrencyInput";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModal } from "@/core/helpers/dom";

export default {
  emits: ["exibirModalAlterarPrecoVenda", "confirmarAlterarPrecoVenda"],
  components: { CurrencyInput },
  props: {
    pedido: { type: Object, required: true },
  },
  methods: {
    bloquearValorNegativo() {
      //Metódo para não permitir valor de alteracao negativo
      this.valorAlteracao = Math.abs(this.valorAlteracao);
    },
    atualizar() {
      var radio = document.getElementsByName("rbAlterar");
      //Deduzir em R$
      if (radio[0].checked) {
        this.labelDeduzir = "Deduzir R$";
      }
      //Deduzir em %
      if (radio[1].checked) {
        this.labelDeduzir = "Deduzir %";
      }
      //Acréscimo em R$
      if (radio[2].checked) {
        this.labelDeduzir = "Acréscimo R$";
      }
      //Acréscimo em %
      if (radio[3].checked) {
        this.labelDeduzir = "Acréscimo %";
      }
      setTimeout(() => {
        this.nextFocus("txtValorAlteracao");
      }, 100);
    },
    async confirmar(retornarValorOriginal) {
      var ficaraComValorZerado = false;
      if (retornarValorOriginal === false) {
        if (this.valorAlteracao === null || this.valorAlteracao <= 0) {
          await this.$swal.showInvalidAlert(
            "O valor deve ser maior que zero!",
            (alert) => {
              this.$utils.requestFocus("txtValorAlteracao");
            }
          );
        } else {
          var radio = document.getElementsByName("rbAlterar");
          //Deduzir em %
          if (radio[1].checked) {
            ficaraComValorZerado =
              this.retornarSeExisteItemComValorNegativado(true);

            if (ficaraComValorZerado === false) {
              await this.$swal.showQuestionAlert(
                "Confirma a dedução de (" +
                  this.$utils.formatarNumero(this.valorAlteracao) +
                  ")% do preço de venda de todos os itens? Neste processo todos descontos ou acréscimos aplicados anteriormente serão retirados!",
                (alert) => {
                  if (alert.isConfirmed) {
                    this.deduzirAcrescentarPrecoVenda(true, true); //1º True=> indica se é porcentagem, 2º True=> indica se é dedução
                  } else {
                    this.fecharModal();
                  }
                }
              );
            } else {
              await this.$swal.showInvalidAlert(
                "Não será possível prosseguir, pois existe item que ficará com o preço de venda zerado ou negativo!",
                (alert) => {
                  this.$utils.requestFocus("txtValorAlteracao");
                }
              );
            }
          }
          //Deduzir em R$
          else if (radio[0].checked) {
            ficaraComValorZerado =
              this.retornarSeExisteItemComValorNegativado(false);

            if (ficaraComValorZerado === false) {
              await this.$swal.showQuestionAlert(
                "Confirma a dedução de R$(-" +
                  this.$utils.formatarNumero(this.valorAlteracao) +
                  ") do preço de venda de todos os itens? Neste processo todos descontos ou acréscimos aplicados anteriormente serão retirados!",
                (alert) => {
                  if (alert.isConfirmed) {
                    this.deduzirAcrescentarPrecoVenda(false, true); //1º True=> indica se é porcentagem, 2º True=> indica se é dedução
                  } else {
                    this.fecharModal();
                  }
                }
              );
            } else {
              await this.$swal.showInvalidAlert(
                "Não será possível prosseguir, pois existe item que ficará com o preço de venda zerado ou negativo!",
                (alert) => {
                  this.$utils.requestFocus("txtValorAlteracao");
                }
              );
            }
          }
          //Acréscimo em %
          else if (radio[3].checked) {
            await this.$swal.showQuestionAlert(
              "Confirma o acréscimo de (" +
                this.$utils.formatarNumero(this.valorAlteracao) +
                ")% do preço de venda de todos os itens? Neste processo todos descontos ou acréscimos aplicados anteriormente serão retirados!",
              (alert) => {
                if (alert.isConfirmed) {
                  this.deduzirAcrescentarPrecoVenda(true, false); //1º True=> indica se é porcentagem, 2º True=> indica se é dedução
                } else {
                  this.fecharModal();
                }
              }
            );
          }
          //Acréscimo em R$
          else if (radio[2].checked) {
            await this.$swal.showQuestionAlert(
              "Confirma o acréscimo de R$(" +
                this.$utils.formatarNumero(this.valorAlteracao) +
                ") do preço de venda de todos os itens? Neste processo todos descontos ou acréscimos aplicados anteriormente serão retirados!",
              (alert) => {
                if (alert.isConfirmed) {
                  this.deduzirAcrescentarPrecoVenda(false, false); //1º True=> indica se é porcentagem, 2º True=> indica se é dedução
                } else {
                  this.fecharModal();
                }
              }
            );
          }
        }
      } else {
        await this.$swal.showQuestionAlert(
          "Confirma aplicar o preço de venda original cadastrado no estoque em todos os itens? Neste processo todos descontos ou acréscimos aplicados anteriormente serão retirados!",
          async (alert) => {
            if (alert.isConfirmed) {
              await this.retornarPrecoVendaOriginal();
              this.$emit("confirmarAlterarPrecoVenda");
            }
            this.fecharModal();
          }
        );
      }
    },
    retornarSeExisteItemComValorNegativado(tipoPorcentagem) {
      var existeRegistro = false;
      for (var i = 0; i < this.pedidoItem.length; i++) {
        var preco = this.pedidoItem[i].preco;
        if (tipoPorcentagem === true) {
          preco = preco - (preco * this.valorAlteracao) / 100;
        } else {
          preco = preco - this.valorAlteracao;
        }
        if (preco <= 0) {
          existeRegistro = true;
        }
      }
      return existeRegistro;
    },
    retornarPrecoVendaOriginal() {
      //remover descontos e acrescimos
      //Voltar ao Preço de venda cadastrado
      for (var i = 0; i < this.pedidoItem.length; i++) {
        this.pedidoItem[i].desconto = 0;
        this.pedidoItem[i].acrescimo = 0;
        this.pedidoItem[i].preco = this.pedidoItem[i].Produto.preco;
      }
    },
    async deduzirAcrescentarPrecoVenda(tipoPorcentagem, tipoDeduzir) {
      //Voltar ao Preço de venda cadastrado antes de aplicar o ajuste e remover descontos e acrescimos
      await this.retornarPrecoVendaOriginal();
      for (var i = 0; i < this.pedidoItem.length; i++) {
        if (tipoDeduzir === true) {
          if (tipoPorcentagem === true) {
            //Deduzir o Preço de venda em porcentagem
            this.pedidoItem[i].preco =
              this.pedidoItem[i].preco -
              (this.pedidoItem[i].preco * this.valorAlteracao) / 100;
          } else {
            //Deduzir o Preço de venda em valor
            this.pedidoItem[i].preco =
              this.pedidoItem[i].preco - this.valorAlteracao;
          }
        }

        if (tipoDeduzir === false) {
          if (tipoPorcentagem === true) {
            //Acrescentar o Preço de venda em porcentagem
            this.pedidoItem[i].preco =
              this.pedidoItem[i].preco +
              (this.pedidoItem[i].preco * this.valorAlteracao) / 100;
          } else {
            //Acrescentar o Preço de venda em valor
            this.pedidoItem[i].preco =
              this.pedidoItem[i].preco + this.valorAlteracao;
          }
        }
      }
      this.fecharModal();
      this.$emit("confirmarAlterarPrecoVenda");
    },
    fecharModal() {
      hideModal(this.$refs.kt_modal_alterar_preco_venda);
      this.$emit("exibirModalAlterarPrecoVenda", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  mounted() {
    this.pedidoItem = this.pedido.PedidoItem;
    this.valorAlteracao = 0;
    this.labelDeduzir = "Deduzir R$";
    this.$utils.requestFocus("txtValorAlteracao");
  },
  data() {
    return {
      timeOut: null,
      pedidoItem: [],
      valorAlteracao: 0,
      labelDeduzir: "",
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style></style>
